module.exports = __webpack_public_path__ + "img/icon18.487f92d5.f8bf80c5.svg";